import { useState } from 'react';

export const useSavedPaymentMethod = () => {
  const [savedPaymentMethod, setSavedPaymentMethod] = useState('');

  return { savedPaymentMethod, setSavedPaymentMethod };
};
